import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#ea4d36',
    },
    secondary: {
      main: '#f1983621',
    },
    error: {
      main: red.A400,
    },
    
  },
});

export default theme;
